import { render, staticRenderFns } from "./fgartic.vue?vue&type=template&id=666c96e9&scoped=true&"
import script from "./fgartic.vue?vue&type=script&lang=js&"
export * from "./fgartic.vue?vue&type=script&lang=js&"
import style0 from "./fgartic.vue?vue&type=style&index=0&id=666c96e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666c96e9",
  null
  
)

export default component.exports